import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";
import axios from "axios";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
//common
const token = window.localStorage.getItem("token");
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: `${token}`
    }
};
// const baseURL = process.env.REACT_APP_API_URL;
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
class AddLeadPipeline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validation: "",
            redirect: null
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeValidation = this.onChangeValidation.bind(this);
    }
    handleSubmit(e) {
        e.preventDefault();
        const modifiedV = { ...this.state.validation };
        if (stateV === "") {
            modifiedV["stateV"] = false;
        } else {
            modifiedV["stateV"] = true;
        }
        this.setState({ validation: modifiedV });
    }
    //for change tooltip display propery
    onChangeValidation(fieldName, value) {
        const modifiedV = { ...this.state.validation };
        if (value !== "") {
            modifiedV[fieldName] = true;
        } else {
            modifiedV[fieldName] = false;
        }
        this.setState({ validation: modifiedV });
    }
    showToast(title, message, toastType) {
        //position class
        var positionClass = "toast-top-right";
        toastr.options = {
            positionClass: positionClass,
            timeOut: this.state.timeOut,
            extendedTimeOut: this.state.extendedTimeOut,
            showEasing: this.state.showEasing,
            hideEasing: this.state.hideEasing,
            showMethod: this.state.showMethod,
            hideMethod: this.state.hideMethod,
            showDuration: this.state.showDuration,
            hideDuration: this.state.hideDuration,
        };
        if (toastType === "info") toastr.info(message, title);
        else if (toastType === "warning") toastr.warning(message, title);
        else if (toastType === "error") toastr.error(message, title);
        else toastr.success(message, title);
    }
    render() {
        //meta title
        document.title = "Add Lead Pipeline";
        const { validation } = this.state;
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs title="Lead Pipelines" breadcrumbItem="Add Lead Pipeline" />
                        <Row>
                            <Col xl="12">
                                <Card>
                                    <CardBody>
                                        <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                                leadPipelineName: (this.state && this.state.leadPipelineName) || "",
                                                leadPipelineOrder: (this.state && this.state.leadPipelineOrder) || "",
                                            }}
                                            validationSchema={Yup.object().shape({
                                                leadPipelineName: Yup.string().required(
                                                    "Please Enter Lead Pipeline Name"
                                                ),
                                                leadPipelineOrder: Yup.string().required(
                                                    "Please Enter Lead Pipeline Order"
                                                ),
                                            })}
                                            onSubmit={values => {
                                                axios.post(baseURL + "/api/lead-pipeline", {
                                                    "name": values.leadPipelineName,
                                                    "order": values.leadPipelineOrder,
                                                }, config)
                                                    .then((response) => {
                                                        var toastTitle = "Success";
                                                        var toastMessage = "The lead pipeline has been added successfully.";
                                                        var toastType = "success";
                                                        this.showToast(toastTitle, toastMessage, toastType);
                                                        this.setState({ redirect: "/catalogue/lead-pipeline/list" });
                                                    })
                                                    .catch((error) => {
                                                        var toastTitle = "Failed";
                                                        var toastMessage = "Lead Pipeline Not Added";
                                                        var toastType = "error";
                                                        this.showToast(toastTitle, toastMessage, toastType);
                                                    });
                                            }}
                                        >
                                            {({ errors, status, touched }) => (
                                                <Form className="needs-validation">
                                                    <Row>
                                                        <Col md="12">
                                                            <FormGroup className="mb-3 d-flex">
                                                                <Label className="col-md-2 col-form-label" htmlFor="leadPipelineName">
                                                                    Lead Pipeline Name
                                                                </Label>
                                                                <div className="col-md-10">
                                                                    <Field
                                                                        name="leadPipelineName"
                                                                        placeholder="Enter lead pipeline name"
                                                                        type="text"
                                                                        className={
                                                                            "form-control" +
                                                                            (errors.leadPipelineName && touched.leadPipelineName
                                                                                ? " is-invalid"
                                                                                : "")
                                                                        }
                                                                    />
                                                                    <ErrorMessage
                                                                        name="leadPipelineName"
                                                                        component="div"
                                                                        className="invalid-feedback"
                                                                    />
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="12">
                                                            <FormGroup className="mb-3 d-flex">
                                                                <Label className="col-md-2 col-form-label" htmlFor="leadPipelineOrder">
                                                                    Lead Pipeline Order
                                                                </Label>
                                                                <div className="col-md-10">
                                                                    <Field
                                                                        name="leadPipelineOrder"
                                                                        placeholder="Enter lead pipeline order"
                                                                        type="text"
                                                                        className={
                                                                            "form-control" +
                                                                            (errors.leadPipelineOrder && touched.leadPipelineOrder
                                                                                ? " is-invalid"
                                                                                : "")
                                                                        }
                                                                    />
                                                                    <ErrorMessage
                                                                        name="leadPipelineOrder"
                                                                        component="div"
                                                                        className="invalid-feedback"
                                                                    />
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Button color="primary" type="submit" className="float-end">
                                                        Add Lead Pipeline
                                                    </Button>
                                                </Form>
                                            )}
                                        </Formik>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
export default AddLeadPipeline;